import { BusinessAreasKey } from '@/modules/BusinessAreas/queries/keys';
import { CompanyKeys } from '@/modules/Companies/queries';
import { OrganizationKeys } from '@/modules/Organizations/queries/keys';
import { ProcessKey } from '@/modules/Processes/queries';
import { TaskKey } from '@/modules/Tasks/queries';
import { UserKey } from '@/modules/Users/queries/types';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

export const useInvalidateUserQueries = () => {
  const queryClient = useQueryClient();

  return useCallback(() => {
    queryClient.invalidateQueries(UserKey.ALL);
    queryClient.invalidateQueries(TaskKey.ALL);
    queryClient.invalidateQueries(ProcessKey.ALL);
    queryClient.invalidateQueries(BusinessAreasKey.ALL);
    queryClient.invalidateQueries(CompanyKeys.ALL);
    queryClient.invalidateQueries(OrganizationKeys.ALL);
  }, [queryClient]);
};
